import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesOffers } from "../../constants";
import { OfferDetails } from "../../offers.types";

export const requestGetOffer = async (
  offerId?: string
): Promise<OfferDetails> => {
  return await instance.get(
    buildUrl(ApiRoutesOffers.SpecialOffers, offerId ?? "")
  );
};
